// Expone la versión del back (v1/v2) a partir del payload público del JWT.
// En v2 el payload incluye `version: "v2"`; en v1 el campo no existe.

function decodeJwtPayload(token) {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(jsonPayload);
  } catch {
    return null;
  }
}

function getPickoVersion() {
  try {
    const user = JSON.parse(localStorage.getItem('user'));
    if (!user || !user.accessToken) {
      return 'v1';
    }
    const payload = decodeJwtPayload(user.accessToken);
    return payload && payload.version === 'v2' ? 'v2' : 'v1';
  } catch {
    return 'v1';
  }
}

function isPickoV1() {
  return getPickoVersion() === 'v1';
}

function isPickoV2() {
  return getPickoVersion() === 'v2';
}

const PickoVersion = {
  get: getPickoVersion,
  isV1: isPickoV1,
  isV2: isPickoV2,
};

export default {
  install(app) {
    app.mixin({
      computed: {
        pickoVersion() {
          return getPickoVersion();
        },
      },
    });
    app.config.globalProperties.$PickoVersion = PickoVersion;
  },
};

export { getPickoVersion, isPickoV1, isPickoV2, PickoVersion };